import {useState} from 'react';

import {Header, Tabs} from '@/components';
import BusinessCountryList from '@/screens/Settings/BusinessCountry';
import CountryList from '@/screens/Settings/Country';
import CurrencyList from '@/screens/Settings/Currency';
import type {TabItem} from '@/types';

const ConfigPage = () => {
  const [countryTotal, setCountryTotal] = useState('');
  const [businessCountryTotal, setBusinessCountryTotal] = useState('');
  const [currencyTotal, setCurrencyTotal] = useState('');

  // Business Countries sits between the two so the consumer and business
  // views of the same concept read together, rather than with the currency
  // catalogue in between.
  const configTabs: TabItem[] = [
    {
      id: 'countryList',
      title: `Countries ${countryTotal}`,
      content: <CountryList setCountryTotal={setCountryTotal} />,
    },
    {
      id: 'businessCountryList',
      title: `Business Countries ${businessCountryTotal}`,
      content: (
        <BusinessCountryList
          setBusinessCountryTotal={setBusinessCountryTotal}
        />
      ),
    },
    {
      id: 'currenciesList',
      title: `Currencies ${currencyTotal}`,
      content: <CurrencyList setCurrencyTotal={setCurrencyTotal} />,
    },
  ];
  return (
    <main className="mt-10 mb-5 mx-4 md:mx-10">
      <Header title="Configurations" />
      <Tabs tabs={configTabs} />
    </main>
  );
};

export default ConfigPage;
